import { useTranslation } from "react-i18next";
import { StatPill } from "./ChartPill";
import { ChartModeToggle } from "./ChartModeToggle";

// هيدر المنحنى: عنوان + مبدّل عرض على نفس السطر (يمين/يسار) — الشارات تحت في سطر مستقل.
export const ChartHeader = ({ totals, mode, setMode }) => {
  const { t } = useTranslation();
  const stats = [
    { key: "present", tone: "bg-emerald-500 text-emerald-500", label: t("dashboard.present"), value: totals.present },
    { key: "late",    tone: "bg-amber-500 text-amber-500",     label: t("check.late"),        value: totals.late },
    { key: "absent",  tone: "bg-rose-500 text-rose-500",       label: t("dashboard.absent"),  value: totals.absent },
    { key: "rate",    tone: "bg-sky-500 text-sky-500",         label: t("dashboard.rate"),    value: `${totals.rate}%` },
  ];
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <p className="label-xs text-sm">{t("dashboard.trend")}</p>
        <ChartModeToggle mode={mode} setMode={setMode} />
      </div>
      <div className="flex flex-wrap gap-2">
        {stats.map((s) => (
          <StatPill key={s.key} tone={s.tone} label={s.label} value={s.value} />
        ))}
      </div>
    </div>
  );
};
